const commonCN = {
    COMMON_01:'已支付',
    COMMON_02:'支付遇到问题',
    COMMON_03:'参数错误！',
    COMMON_04:'充值失败！请重新充值！',
    COMMON_05:'充值成功！',
    COMMON_06:'支付宝',
    COMMON_07:'请输入大于0的金额',
    COMMON_08:'发送验证码',
    COMMON_09:'重新发送',
    COMMON_10:'请输入金额',
    CANCELLIMIT:'取消翻页限制',

    C001:'收藏成功',
    C002:'收藏失败'
}
export default commonCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_common.js